import { HTMLAttributes } from 'react';
import ReactPlayer, { ReactPlayerProps } from 'react-player';
import styles from './styles.module.scss';

export type VideoPlayerProps = HTMLAttributes<HTMLDivElement> & ReactPlayerProps;

export const VideoPlayer = ({ url, ...props }: VideoPlayerProps) => (
  <div className={styles.playerWrapper}>
    <ReactPlayer className={styles.reactPlayer} url={url} width="100%" height="100%" {...props} />
  </div>
);
